export default {
  ['search'](state, payload) {
    state.total = payload.total;
    state.pages = payload.pages;
    state.page = payload.page;
    state.limit = payload.limit;
    state.sortBy = payload.sortBy;
    state.sortDesc = payload.sortDesc;
    state.conditions = payload.conditions;
    state.list = payload.list;
  },

  ['replaceMessage'](state, payload) {
    state.form.message = payload.pre + payload.add + payload.post;
  },

  ['loadForm'](state, payload) {
    state.form.id = payload.id;
    state.form.number = payload.number;
    state.form.subject = payload.subject;
    state.form.message = payload.message;
    state.form.is_send = false;
  },

  ['clearForm'](state, payload) {
    state.form.id = null;
    state.form.number = null;
    state.form.subject = '';
    state.form.message = '';
    state.form.is_send = false;
  },

  ['inputSubject'](state, payload) {
    state.form.subject = payload;
  },

  ['inputMessage'](state, payload) {
    state.form.message = payload
  },
};
